import "./DesktopHistoryTable.css";

import { Col, HistoryModel } from "../../../../models/fineModels";
import {
  faAngleDown,
  faCaretDown,
  faCaretUp,
  faDownload,
  faSearch,
  faSort,
} from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";

import CustomInput from "../../../CustomInput/CustomInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { downloadFile } from "../../../../api/infringement";

interface DesktopFineTableProps {
  data: HistoryModel[] | null;
}

const DesktopHistoryTable = ({ data }: DesktopFineTableProps) => {
  const [sortedColumn, setSortedColumn] = useState<Col | null>(null);
  const [isAscending, setIsAscending] = useState<boolean>(false);
  const [limit, setLimit] = useState<number>(10);
  const [fines, setFines] = useState<HistoryModel[] | null>(data);

  const [search, setSearch] = useState<string | null>(null);

  let columns: Col[] = [
    { title: "Traffic Notice", accessor: "account_number" },
    { title: "ID Number", accessor: "id_number" },
    {
      title: "Amount",
      accessor: "amount_paid",
    },
    {
      title: "Date Paid",
      accessor: "date_paid",
    },
    {
      title: "Status",
      accessor: "warrant_status",
    },
    {
      title: "Documents",
      accessor: "documents",
    },
  ];

  const onHeaderItemClicked = (col: Col) => {
    setIsAscending(true);
    setSortedColumn(col);
    if (sortedColumn && isAscending) setIsAscending(false);
    let accessor = sortedColumn?.accessor as keyof HistoryModel;
    let sortedFines = fines;
    if (sortedFines) {
      sortedFines = sortedFines
        ?.slice()
        .sort((a: HistoryModel, b: HistoryModel) => {
          if (a && b && accessor) {
            if (a[accessor] < b[accessor]) {
              return isAscending ? 1 : -1;
            }
            if (a[accessor] > b[accessor]) {
              return isAscending ? -1 : 1;
            }
          }
          return 0;
        });
      setFines(sortedFines);
    }
  };

  const onDownloadClicked = async (account: string) => {
    downloadFile(account);
  };
  const onLoadMoreClicked = () => {
    setLimit(limit + 10);
  };

  useEffect(() => {
    let finesCopy = fines;
    if (search && search?.length > 0 && finesCopy) {
      finesCopy = finesCopy?.filter((fine) => {
        const idNo = fine.id_number;
        let accNo = fine?.account_number
          .toLowerCase()
          .replace(/\//g, "")
          .trim();
        let query = search.toLowerCase().replace(/\//g, "").trim();
        return accNo.includes(query) || idNo.toLowerCase().includes(query);
      });
      setFines(finesCopy!);
    } else {
      setFines(data);
    }
  }, [search]);

  return (
    <div className="desktop-history-container">
      <CustomInput
        placeholder="Search"
        value={search}
        setValue={setSearch}
        inputStyle={{
          fontSize: 13,
          width: "10%",
          minWidth: 155,
          minHeight: 32,
        }}
        containerStyle={{ marginTop: 13, position: "relative" }}
        icon={<FontAwesomeIcon icon={faSearch} className="search-icon" />}
      />
      {fines && fines?.length > 0 ? (
        <table className="desktop-table">
          <thead className="table-header">
            <tr>
              {columns.map((col, index) => (
                <td
                  onClick={() =>
                    col !== columns[0] &&
                    col !== columns[5] &&
                    onHeaderItemClicked(col)
                  }
                  key={index}
                  style={{
                    cursor:
                      col === columns[0] || col === columns[5]
                        ? "initial"
                        : "pointer",
                  }}
                >
                  {col.title}
                  {sortedColumn && col.title === sortedColumn.title ? (
                    <FontAwesomeIcon
                      icon={isAscending ? faCaretUp : faCaretDown}
                      size="1x"
                      color="white"
                      style={{ marginLeft: 10 }}
                    />
                  ) : index !== 0 &&
                    index !== 5 &&
                    col.title !== sortedColumn?.title ? (
                    <FontAwesomeIcon
                      icon={faSort}
                      size="1x"
                      color="white"
                      className="sort-icon"
                      style={{ marginLeft: 10, height: 14 }}
                    />
                  ) : null}
                </td>
              ))}
            </tr>
          </thead>
          <tbody>
            {fines
              ?.slice(0, limit < fines.length ? limit : fines.length)
              .map((fine, index) => (
                <tr key={index}>
                  <td>{fine.account_number.replace(/\//g, "")}</td>
                  <td>{fine.id_number}</td>
                  <td>R{Number(fine.amount_paid) / 100}</td>
                  <td>{fine.date_paid}</td>
                  <td>{fine.warrant_status}</td>

                  <td>
                    <div
                      className="continue-to-fine-button"
                      onClick={() => onDownloadClicked(fine.account_number)}
                    >
                      <FontAwesomeIcon
                        icon={faDownload}
                        size="1x"
                        color="white"
                        className="sort-icon"
                        style={{ marginLeft: 10, height: 14 }}
                      />
                      <p>Download</p>
                    </div>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      ) : (
        <p className="zero-fines-found">0 fines found</p>
      )}

      {fines && limit < fines?.length ? (
        <div className="load-more-button-container">
          <div
            className="load-more-fines-button"
            onClick={() => onLoadMoreClicked()}
          >
            <p>Load More</p>
            <FontAwesomeIcon
              icon={faAngleDown}
              size="1x"
              color="#18283c"
              style={{ marginLeft: 10 }}
            />
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default DesktopHistoryTable;
